import {
    SCHEDULED_REPORTS_OPEN_MODAL,
    SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
    nextToken: null,
    openModal: false,
    detail: null,
    contacts: null,
    contactsOpenModal: false,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case SCHEDULED_REPORTS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, detail: action?.payload?.detail }
        
        case SCHEDULED_REPORTS_CONTACTS_OPEN_MODAL:
            return { ...state, contacts: action.payload.contacts, contactsOpenModal: action.payload.open }

        case CLEAR_REDUX:
            return ["", "SCHEDULED_REPORTS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};